import React, { useEffect, useState, useContext, } from 'react';
import { Icon, Header, Segment, Container, Grid, Label, Message,  Card, Input, } from 'semantic-ui-react'
import { useToasts } from 'react-toast-notifications';
import { ConnectWS } from '../../../../ConnectWS';
import AuthContext from '../../../../context/authContext';
import { changeInitialScale, getPercentValue, getlinkplayerprofile, loadingShow, mobileW } from '../../../../myfunctions';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import { faImage, faBaby, faUserTie, faUserSecret, faUserNinja, faChildReaching, faSkull, faChartLine, faUser, faPersonRays } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ShowImgAvatar from '../../../../tools/ShowImgAvatar';
import { useHistory, useParams } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ShowPagination from '../../../../tools/ShowPagination';
import moment from 'moment';

function Achievements(props) {
  const { addToast } = useToasts();
  const authContext = useContext(AuthContext);
  const { width, height } = useWindowDimensions();// eslint-disable-line no-unused-vars
  const { achievementsId } = useParams()


  const [dataRow, setdataRow] = useState([])
  const [totalRow, settotalRow] = useState(0)

  let history = useHistory();


  const [loading, setloading] = useState(true)

 


  var settings = {
    dots: false,
    infinite: true,
    slidesToShow: width>1650 ? 5 : width>1000 ? 3 : width>700 ? 2 : 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    swipeToSlide: true,
  };

  function getProfileData(aid) {
    setloading(true)
    ConnectWS("/generator/getAchievementById ", null, { achievement_id : aid,season_id:2 }, function (response, logout) {
      if (logout === 1) {
      } else if (response && response.status && Number(response.status) === 200) {
        setdataRow({ current: response.data.data, filter: null, data: response.data.data, activePage: 1 })
        settotalRow(response.data.total_members)
      } else {
        if(logout===101){
          addToast(response, { appearance: 'info' });
        }else if(logout===102){
          addToast(response, { appearance: 'warning' });
        }else{
          addToast(response, { appearance: 'error' });
        }
        // history.push("/404")
      }
      setloading(false)
    });


  }

  useEffect(() => {
    if (Number(process.env.REACT_APP_API_DEBUG) === 1) {
      console.log("View: Achievements")
    }
    getProfileData(Number(achievementsId))
    changeInitialScale(1)
    return () => {
    }; // use effect cleanup to set flag false, if unmounted
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  function getSegmentProfile(row, k) {
    return <Grid.Column key={k} style={{ marginBottom: 15 }}>
      <Segment className='CardProfileAchieve' >
        {width>500 ? <Icon style={{ position: "absolute", right: 0, top: 5 }} name="check circle" color={'green'} size='big' /> : ""}
        
        <figure className='imgPlayer'><ShowImgAvatar urlpic={row.member_img} mtype={"0"} msize={'massive'} /><figcaption style={{ fontSize: 20 }}>{getlinkplayerprofile(row.member_id, row.member_name)}
          <br /> <span style={{ fontSize: 11, opacity: 0.8 }}><Icon name="calendar" />Data osiągnięcia: {row.dtstop}</span>
        </figcaption></figure>

      </Segment>
    </Grid.Column>
  }

  function getRowArr(id2) {
    return AchievementsEnum().filter(
      function (data) { return data.id === id2 }
    );
  }

  function getDataAchieve(achievementsId) {
    let found = getRowArr(Number(achievementsId));
    if (found.length === 1) {
      return <Segment >
        <Label color='blue' ribbon style={{ marginBottom: 10 }}>
          SZEGÓŁY OSIAGNIĘCIA
        </Label>
        <Container textAlign='center' style={{position:"relative"}}>
        
          <Header as='h2' icon>
            <FontAwesomeIcon style={{ marginBottom: 25, fontSize: 80 }} icon={found[0].img} />
            <br />
            {found[0].title}
            <Header.Subheader>
              {found[0].desc}
            </Header.Subheader>
          </Header>
          <br/>
          <div style={{lineHeight:"14px" }}>
          <span style={{fontSize:14}}>Osiągnięcie zdobyte przez <b>{dataRow.data ? dataRow.data.length  : "NnN"}</b> profili {dataRow.data ? getPercentValue(dataRow.data.length,totalRow) : ""}</span><br/>
          </div>
        </Container>
      </Segment>
    } else {
      history.push("/404")
      return ""
    }


  }


  

  function clickCard(aid){
    history.push("/osiagniecia/"+aid)
    getProfileData(Number(aid))
  }

  
  function getCardSuccess(inId,inValue, inTotal, inText, inDesc, inCountProfile, inImage,inDtstop) {
    return <div style={{width:"100%",height:175}}> <Card style={{margin:"0 auto"}}  link onClick={()=>clickCard(inId)} className={'noBorder ribbonbox colorSegmentCardDarkSukcesy0'}>
     <div className="ribbonWrap ribbon-top-left"><span>ZOBACZ</span></div>
      <Card.Content >

        <FontAwesomeIcon style={{ marginBottom: 25, marginTop: 15, fontSize: 50 }} icon={inImage ? inImage : ""} />
        <Card.Header  >{inText ? inText : "n/n"}</Card.Header>
        
        <Card.Description style={{fontSize:14}}>
          {inDesc ? inDesc : "n/n"}
        </Card.Description>
        
      </Card.Content>
     
    
    </Card></div>
  }

  function getTabByFiltr(dataSearch, co, setco, rowCurrenttmp) {

    if (dataSearch !== "" && dataSearch.length > 2 && co.data && co.data.length > 0) {
      let tmparr = []
      co.data.forEach(element => {

        if (JSON.stringify(element).toUpperCase().includes(dataSearch.toUpperCase())) {
          tmparr.push(element)
        }
      });
      setco({ ...co, current: tmparr })

    } else if (dataSearch !== "") {

    } else {
      setco({ ...co, current: co.data.slice(0, rowCurrenttmp) })
    }

  }

  return (
    <div className={authContext.darkMode ? 'bgDartTheme' : ''}>
    <div style={{ minHeight: height, paddingTop: 30, paddingBottom: 30, marginTop: -20, marginBottom: -20, }} className={authContext.darkMode ? 'bgCenterPanelDark' : ''}>
  
      <Container style={{ marginBottom: 20 }}>
      
      <Segment textAlign='center'  style={{marginBottom:30}}>
      <Slider {...settings} >
    {AchievementsEnum().map((row,i)=><div key={i}>{getCardSuccess(row.id,row.currVal, row.maxVal, row.title, row.desc,row.currProfile, row.img,row.dtstop)}</div>)}
   
   </Slider>
   </Segment>
        {getDataAchieve(achievementsId)}
        <Segment textAlign='center'>
          <div style={{ fontSize: 12,lineHeight:"14px" }}>
          Reset osiągnięć 01-01-{moment().year()+1}r.
            <br />
          <span style={{fontSize:11}}>Osiągnięcia są aktualizowane raz na dobę w godzinach nocnych.</span>
          </div>
        </Segment>
      </Container>
      <Container>
        <Segment>

          <Label color='blue' ribbon style={{ marginBottom: 10 }}>
            PROFILE
          </Label>
          <Input size='mini' style={{ marginBottom: 10 }} fluid icon='search' onChange={(e, d) => getTabByFiltr(d.value, dataRow, setdataRow, width < mobileW() ? 4 : 12)} placeholder={"Szukaj... min 3 znaki"} />

          {loading ? loadingShow() :
            <>
              <Grid stackable>
                <Grid.Row columns={dataRow.current.length >= 4 ? 4 : dataRow.current.length} >
                  {dataRow && dataRow.current.length > 0 ? dataRow.current.map((row, k) => getSegmentProfile(row, k))
                    : ""}

                </Grid.Row>
              </Grid>
              {dataRow && dataRow.current.length > 0 ?
              <ShowPagination myTab={dataRow} setMyTab={setdataRow} rowCurrent={width < mobileW() ? 5 : 18} darkOn={true} />
              :<Message> BRAK PROFILI</Message>}
              
            </>}
        </Segment>
      </Container>
    </div>
    </div>
  )
}

export default Achievements;


export function AchievementsEnum() {
  try {
    return [{ id: 1, title: "PROFIL", desc: "Wgraj swoje zdjęcie profilowe", currVal: 0, maxVal: 1, currProfile: 0, img: faImage,dtstop:null },
    { id: 2, title: "NOWICJUSZ", desc: "Rozegraj 3 turnieje / ligi", currVal: 0, maxVal: 3, currProfile: 0, img: faBaby,dtstop:null },
    { id: 3, title: "DOŚWIADCZONY 10", desc: "Rozegraj 10 turniejów / lig", currVal: 0, maxVal: 10, currProfile: 0, img: faUser ,dtstop:null},
    { id: 4, title: "DOŚWIADCZONY 40", desc: "Rozegraj 40 turniejów / lig", currVal: 0, maxVal: 40, currProfile: 0, img: faUserTie,dtstop:null },
    { id: 5, title: "DOŚWIADCZONY 80", desc: "Rozegraj 80 turniejów / lig", currVal: 0, maxVal: 80, currProfile: 0, img: faUserSecret ,dtstop:null},
    { id: 6, title: "DOŚWIADCZONY 100", desc: "Rozegraj 100 turniejów / lig", currVal: 0, maxVal: 100, currProfile: 0, img: faUserNinja,dtstop:null },
    { id: 7, title: "ZWYCIĘSKA PASSA 5", desc: "Wygraj 5 pojedynków z rzędu", currVal: 0, maxVal: 5, currProfile: 0, img: faChildReaching ,dtstop:null},
    { id: 8, title: "ZWYCIĘSKA PASSA 10", desc: "Wygraj 10 pojedynków z rzędu", currVal: 0, maxVal: 10, currProfile: 0, img: faChildReaching ,dtstop:null},
    { id: 9, title: "ZWYCIĘSKA PASSA 15", desc: "Wygraj 15 pojedynków z rzędu", currVal: 0, maxVal: 15, currProfile: 0, img: faChildReaching ,dtstop:null},
    { id: 10, title: "ZWYCIĘSKA PASSA 20", desc: "Wygraj 20 pojedynków z rzędu", currVal: 0, maxVal: 20, currProfile: 0, img: faChildReaching ,dtstop:null},
    { id: 11, title: "ZWYCIĘSKA PASSA 25", desc: "Wygraj 25 pojedynków z rzędu", currVal: 0, maxVal: 20, currProfile: 0, img: faChildReaching ,dtstop:null},
    { id: 12, title: "ZWYCIĘSKA PASSA 30", desc: "Wygraj 30 pojedynków z rzędu", currVal: 0, maxVal: 20, currProfile: 0, img: faSkull ,dtstop:null},
    { id: 13, title: "ELO 1600", desc: "Osiągnij punktację 1600 w ELO", currVal: 0, maxVal: 1, currProfile: 0, img: faChartLine ,dtstop:null},
    { id: 14, title: "ELO 2000", desc: "Osiągnij punktację 2000 w ELO", currVal: 0, maxVal: 1, currProfile: 0, img: faChartLine ,dtstop:null},
    { id: 15, title: "ELO 2500", desc: "Osiągnij punktację 2500 w ELO", currVal: 0, maxVal: 1, currProfile: 0, img: faChartLine ,dtstop:null},
    { id: 16, title: "ELO 3000", desc: "Osiągnij punktację 3000 w ELO", currVal: 0, maxVal: 1, currProfile: 0, img: faChartLine ,dtstop:null},
    { id: 17, title: "TRENUJĄCY 5", desc: "Weź udział w 5 treningach", currVal: 0, maxVal: 10, currProfile: 0, img: faPersonRays ,dtstop:null},
    { id: 18, title: "TRENUJĄCY 15", desc: "Weź udział w 15 treningach", currVal: 0, maxVal: 20, currProfile: 0, img: faPersonRays ,dtstop:null},
    { id: 19, title: "TRENUJĄCY 35", desc: "Weź udział w 35 treningach", currVal: 0, maxVal: 35, currProfile: 0, img: faPersonRays ,dtstop:null},
    { id: 20, title: "TRENUJĄCY 50", desc: "Weź udział w 50 treningach", currVal: 0, maxVal: 50, currProfile: 0, img: faPersonRays ,dtstop:null}
  ]
  
  } catch (error) {
    return []
  }
}
